import React from 'react';

import { Badge, Box } from '@mui/material';
import { INavigationSection, NavigationLink } from '../sidebar.type';

import { ToolbarSidebarButton } from '../../toolbar/toolbar-sidebar-button';
import {
  NavigationSectionsWrapper,
  NavigationWrapper,
  SectionTitle,
  SectionWrapper,
  SidebarItem,
  SidebarItemIcon,
  StyledLink,
} from './navigation-section.style';
import { OptionalTooltip } from './optional-tooltip';

function NavigationSection({
  isSidebarOpen,
  navigationSections,
  onNavigationLinkClick,
}: {
  isSidebarOpen: boolean;
  navigationSections: INavigationSection[];
  onNavigationLinkClick: (navigationLink: NavigationLink) => void;
}): JSX.Element {
  return (
    <NavigationWrapper>
      <NavigationSectionsWrapper>
        <Box display={'flex'} justifyContent={'center'}>
          <Box marginLeft={'auto'}>
            <ToolbarSidebarButton />
          </Box>
        </Box>
        {navigationSections.map(({ label, navigationLinks }, i) => (
          <SectionWrapper key={label} isSidebarOpen={isSidebarOpen && i !== 0}>
            <SectionTitle isSidebarOpen={isSidebarOpen}>{label}</SectionTitle>
            {navigationLinks.map((navigationLink) => (
              <OptionalTooltip
                isVisible={!isSidebarOpen}
                key={navigationLink.path}
                title={`${label} - ${navigationLink.label}`}
                placement="right"
              >
                <StyledLink
                  key={navigationLink.path}
                  onClick={() => onNavigationLinkClick(navigationLink)}
                >
                  <SidebarItem
                    isSidebarOpen={isSidebarOpen}
                    isActive={navigationLink.active}
                  >
                    <SidebarItemIcon isSidebarOpen={isSidebarOpen}>
                      <Box
                        sx={{
                          backgroundColor: (theme) =>
                            theme.palette.background.default,
                          borderRadius: '10px',
                          p: '1px',
                          position: 'relative',
                        }}
                      >
                        <Box
                          sx={{
                            backgroundColor: (theme) =>
                              navigationLink.active
                                ? 'transparent'
                                : theme.palette.primary.lighter,
                            borderRadius: '10px',
                            p: 1,
                            justifyItems: 'center',
                            display: 'flex',
                          }}
                        >
                          {navigationLink.icon}
                        </Box>
                        {!isSidebarOpen && (
                          <Badge
                            badgeContent={navigationLink.updatesCount ?? 0}
                            showZero={false}
                            color="primary"
                            sx={{
                              position: 'absolute',
                              top: 0,
                              left: 0,
                              '& .MuiBadge-badge': {
                                minWidth:
                                  (navigationLink.updatesCount ?? 0) >= 10
                                    ? '30px'
                                    : 'auto',
                                fontSize: '0.8rem',
                              },
                            }}
                          />
                        )}
                      </Box>
                    </SidebarItemIcon>

                    {navigationLink.label}
                  </SidebarItem>
                  {isSidebarOpen && (
                    <Badge
                      badgeContent={navigationLink.updatesCount ?? 0}
                      showZero={false}
                      color="primary"
                      sx={{
                        '& .MuiBadge-badge': {
                          minWidth:
                            (navigationLink.updatesCount ?? 0) >= 10
                              ? '30px'
                              : 'auto',
                          fontSize: '0.8rem',
                        },
                      }}
                    />
                  )}
                </StyledLink>
              </OptionalTooltip>
            ))}
          </SectionWrapper>
        ))}
      </NavigationSectionsWrapper>
    </NavigationWrapper>
  );
}

export { NavigationSection };
